import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const Loader = ({ open, message = '' }) => {
  return (
    <Backdrop
      sx={{ 
        color: '#fff', 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
      {message && (
        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          {message}
        </div>
      )}
    </Backdrop>
  );
};

export default Loader;
